import * as serviceWorker from './serviceWorkerRegistration';
import { AuthProvider } from '@ttoss/react-auth';
import { BrowserRouter } from 'react-router-dom';
import { Modal } from '@ttoss/components';
import { NotificationsProvider } from '@ttoss/react-notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@ttoss/ui';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './amplify';
import 'intro.js/introjs.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});

Modal.setAppElement('#root');

const Application = () => {
  return (
    <React.StrictMode>
      <ThemeProvider
        theme={{
          fonts: {
            body: 'Overlock',
            heading: 'Josefin Sans',
          },
          colors: {
            transparent: '#ffffff00',
            primary: '#127547',
            secondary: '#457F8D',
            text: '#393A3A',
            background: '#F7F9F8',
            accent: '#00C7FE',
            highlight: '#0067D2',
            muted: '#B9B9B9',
            primaryVariant: '#008774',
            secondaryVariant: '#7AB4C3',
            alert: '#FF655B',
            success: '#66AA00',
            caution: '#FC6C00',
            neutral: '#888888',
            eucalipto: '#E79E49',
            pinus: '#EBC36D',
            cedroAustraliano: '#9F4F2A',
            mognoAfricano: '#C18771',
            teca: '#C19358',
          },
        }}
      >
        <NotificationsProvider>
          <AuthProvider>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </QueryClientProvider>
          </AuthProvider>
        </NotificationsProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<Application />);

serviceWorker.register();
